// import { BrowserRouter as Router, useLocation } from 'react-router-dom';
// import MainStack from './Navigations/MainStack';
// import { useEffect } from 'react';

// // Import the hook (or keep the logic inline)
// function usePageTracking() {
//   const location = useLocation();

//   useEffect(() => {
//     if (typeof window.gtag === 'function') {
//       window.gtag('config', 'G-700YYPMMEP', {
//         page_path: location.pathname,
//       });
//     }
//   }, [location]);
// }

// function App() {
//   usePageTracking();

//   return (
//     <>
//       <MainStack />
//     </>
//   );
// }

// export default function AppWrapper() {
//   return (
//     <Router>
//       <App />
//     </Router>
//   );
// }



import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import MainStack from './Navigations/MainStack';
import { useEffect } from 'react';

function usePageTracking() {
  const location = useLocation();
  
   useEffect(() => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView'); // fires on every route change
    }

    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-700YYPMMEP', {
        page_path: location.pathname,
      });
    }
  }, [location]);
}

function App() {
  usePageTracking();

  return (
    <>
      <MainStack />
    </>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
